// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.card {
    background: #fff;
    min-height: 50px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    position: relative;
    margin-bottom: 30px;
    border-radius: 2px;
}

.ticket-container {
          background-color: #f3f4f6;
          padding: 1rem;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }

        .page-buttons {
          display: flex;
          gap: 0.5rem;
          margin-bottom: 1rem;
        }

        .page-buttons button {
          padding: 0.25rem 1rem;
          border: 1px solid #2563eb;
          color: #2563eb;
          background: white;
          border-radius: 0.25rem;
          cursor: pointer;
        }

        .table-container {
          overflow-x: auto;
          background: white;
          border-radius: 0.375rem;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        }

        table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
        }


        th {
          background-color: #f9fafb;
          color: #374151;
          font-weight: 500;
          padding: 0.75rem 1rem;
          font-size: 0.875rem;
        }

        td {
          padding: 0.75rem 1rem;
          border-top: 1px solid #e5e7eb;
          color: #1f2937;
        }
        
        tbody tr:hover {
        background-color: #f1f1f1; /* Light gray hover effect */
        cursor: pointer;
        }

        .ticket-link {
          color: #2563eb;
          text-decoration: none;
        }

        .ticket-link:hover {
          text-decoration: underline;
        }

        .win-points {
          background-color: #22c55e;
          color: white;
          
           
          min-width: 4rem;
          text-align: center;
        }

        .claimed {
          background-color: #3b82f6;
          color: white;
           
          
          align-items: center;
          gap: 0.25rem;
          white-space: nowrap;
        }

        .check-icon {
          font-size: 1.875rem;
        }
        .check-star {
          font-size: 1.875rem;
        }

        .thumbs-down {
          color: #6b7280;
          font-size: 1.25rem;
        }

        .win-position {
           
          color: white;        
          text-align: center;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16), 0 2px 10px rgba(0, 0, 0, 0.12);
            border-radius: 2px;
            border: none;
            font-size: 20px;
            outline: none;
            background-color: #FF9800 !important;
            color: #ffffff;
        }
            .badge {
            display: inline-block;
            min-width: 10px;
            padding: 5px 10px;
            font-size: 18px;
            font-weight: bold;
             
            color: #fff;
            text-align: center;
            white-space: nowrap;
            vertical-align: middle;
            background-color: #777;
            border-radius: 2px;
        }

   .bg-red{
    background-color:red;
    color: white;
    font-size: 18px;
    
   }`, "",{"version":3,"sources":["webpack://./src/pages/TicketDetails.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,kBAAkB;IAClB,mBAAmB;IAInB,kBAAkB;AACtB;;AAEA;UACU,yBAAyB;UACzB,aAAa;UACb,8EAA8E;QAChF;;QAEA;UACE,aAAa;UACb,WAAW;UACX,mBAAmB;QACrB;;QAEA;UACE,qBAAqB;UACrB,yBAAyB;UACzB,cAAc;UACd,iBAAiB;UACjB,sBAAsB;UACtB,eAAe;QACjB;;QAEA;UACE,gBAAgB;UAChB,iBAAiB;UACjB,uBAAuB;UACvB,yCAAyC;QAC3C;;QAEA;UACE,WAAW;UACX,yBAAyB;UACzB,gBAAgB;QAClB;;;QAGA;UACE,yBAAyB;UACzB,cAAc;UACd,gBAAgB;UAChB,qBAAqB;UACrB,mBAAmB;QACrB;;QAEA;UACE,qBAAqB;UACrB,6BAA6B;UAC7B,cAAc;QAChB;;QAEA;QACA,yBAAyB,EAAE,4BAA4B;QACvD,eAAe;QACf;;QAEA;UACE,cAAc;UACd,qBAAqB;QACvB;;QAEA;UACE,0BAA0B;QAC5B;;QAEA;UACE,yBAAyB;UACzB,YAAY;;;UAGZ,eAAe;UACf,kBAAkB;QACpB;;QAEA;UACE,yBAAyB;UACzB,YAAY;;;UAGZ,mBAAmB;UACnB,YAAY;UACZ,mBAAmB;QACrB;;QAEA;UACE,mBAAmB;QACrB;QACA;UACE,mBAAmB;QACrB;;QAEA;UACE,cAAc;UACd,kBAAkB;QACpB;;QAEA;;UAEE,YAAY;UACZ,kBAAkB;YAChB,yEAAyE;YAIzE,kBAAkB;YAClB,YAAY;YACZ,eAAe;YACf,aAAa;YACb,oCAAoC;YACpC,cAAc;QAClB;YACI;YACA,qBAAqB;YACrB,eAAe;YACf,iBAAiB;YACjB,eAAe;YACf,iBAAiB;;YAEjB,WAAW;YACX,kBAAkB;YAClB,mBAAmB;YACnB,sBAAsB;YACtB,sBAAsB;YACtB,kBAAkB;QACtB;;GAEL;IACC,oBAAoB;IACpB,YAAY;IACZ,eAAe;;GAEhB","sourcesContent":["\n.card {\n    background: #fff;\n    min-height: 50px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n    position: relative;\n    margin-bottom: 30px;\n    -webkit-border-radius: 2px;\n    -moz-border-radius: 2px;\n    -ms-border-radius: 2px;\n    border-radius: 2px;\n}\n\n.ticket-container {\n          background-color: #f3f4f6;\n          padding: 1rem;\n          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n        }\n\n        .page-buttons {\n          display: flex;\n          gap: 0.5rem;\n          margin-bottom: 1rem;\n        }\n\n        .page-buttons button {\n          padding: 0.25rem 1rem;\n          border: 1px solid #2563eb;\n          color: #2563eb;\n          background: white;\n          border-radius: 0.25rem;\n          cursor: pointer;\n        }\n\n        .table-container {\n          overflow-x: auto;\n          background: white;\n          border-radius: 0.375rem;\n          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n        }\n\n        table {\n          width: 100%;\n          border-collapse: collapse;\n          text-align: left;\n        }\n\n\n        th {\n          background-color: #f9fafb;\n          color: #374151;\n          font-weight: 500;\n          padding: 0.75rem 1rem;\n          font-size: 0.875rem;\n        }\n\n        td {\n          padding: 0.75rem 1rem;\n          border-top: 1px solid #e5e7eb;\n          color: #1f2937;\n        }\n        \n        tbody tr:hover {\n        background-color: #f1f1f1; /* Light gray hover effect */\n        cursor: pointer;\n        }\n\n        .ticket-link {\n          color: #2563eb;\n          text-decoration: none;\n        }\n\n        .ticket-link:hover {\n          text-decoration: underline;\n        }\n\n        .win-points {\n          background-color: #22c55e;\n          color: white;\n          \n           \n          min-width: 4rem;\n          text-align: center;\n        }\n\n        .claimed {\n          background-color: #3b82f6;\n          color: white;\n           \n          \n          align-items: center;\n          gap: 0.25rem;\n          white-space: nowrap;\n        }\n\n        .check-icon {\n          font-size: 1.875rem;\n        }\n        .check-star {\n          font-size: 1.875rem;\n        }\n\n        .thumbs-down {\n          color: #6b7280;\n          font-size: 1.25rem;\n        }\n\n        .win-position {\n           \n          color: white;        \n          text-align: center;\n            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.16), 0 2px 10px rgba(0, 0, 0, 0.12);\n            -webkit-border-radius: 2px;\n            -moz-border-radius: 2px;\n            -ms-border-radius: 2px;\n            border-radius: 2px;\n            border: none;\n            font-size: 20px;\n            outline: none;\n            background-color: #FF9800 !important;\n            color: #ffffff;\n        }\n            .badge {\n            display: inline-block;\n            min-width: 10px;\n            padding: 5px 10px;\n            font-size: 18px;\n            font-weight: bold;\n             \n            color: #fff;\n            text-align: center;\n            white-space: nowrap;\n            vertical-align: middle;\n            background-color: #777;\n            border-radius: 2px;\n        }\n\n   .bg-red{\n    background-color:red;\n    color: white;\n    font-size: 18px;\n    \n   }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
